import React from 'react';
import {
  HeroHeaderSkeleton,
  SectionHeaderSkeleton,
  SectionSkeleton,
  TabbedRunsSkeleton
} from './blocks';

const FunctionDetailSkeleton: React.FC = () => (
  <>
    <HeroHeaderSkeleton />
    <SectionSkeleton titleWidth={0}>
      <SectionHeaderSkeleton />
      <TabbedRunsSkeleton tabs={1} rows={5} />
    </SectionSkeleton>
  </>
);

export default FunctionDetailSkeleton;
